var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 28,
    viewBox: "0 96 960 960",
    width: 28,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M137 911q-28.725 0-50.862-22.138Q64 866.725 64 838V314q0-28.725 22.138-50.862Q108.275 241 137 241h686q28.725 0 50.862 22.138Q896 285.275 896 314v524q0 28.725-22.138 50.862Q851.725 911 823 911H137Zm343-306L137 383v455h686V383L480 605Zm0-71 343-220H138l342 220ZM133 383v-69 524h4-4V383Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.69c74068e6e10e1c8f222426f4698027.svg";
export { ForwardRef as ReactComponent };